import { render, staticRenderFns } from "./rankingCourseBoard.vue?vue&type=template&id=4a3f7e70&"
import script from "./rankingCourseBoard.vue?vue&type=script&lang=js&"
export * from "./rankingCourseBoard.vue?vue&type=script&lang=js&"
import style0 from "./rankingCourseBoard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports